import { toDataUrl } from "../../items/useFiles";
import companyPicVar from "../../graphql/variables/companyPicVar";
import { VITE_REACT_APP_PUBLIC_S3 } from "../../constants/variables";

const base = `${VITE_REACT_APP_PUBLIC_S3}`;
const time = new Date().getTime();

export const updateCompanyPicture = async (id) => {
  try {
    const img = await fetch(`${base}/companies/${id}?random_number=${time}`);
    if (!img.ok) {
      throw new Error("File not found");
    }
    companyPicVar(await toDataUrl(await img.blob()));
  } catch (_error) {
    companyPicVar(null);
  }
};
